export default {
  server: "https://london.1000heads-1000visitors-server.stage.1000heads.net",
  receptionEmail: "Reception <reception@1000heads.com>",
  baseUrl: "https://london.1000heads-1000visitors.stage.1000heads.net",
  slackToken: "xoxb-2526545672-683465173218-Hn9JOPIpVMTiAgA1k6oUqc8r",
  welcome: ["Ross", "Ross Taylor"]
};